module.exports = __webpack_public_path__ + "img/020048.2188a84d.png";